import CloseIcon from '@/fo/icons/base/icons/close24.svg';
import { Option } from '@/fo/ui/kit/listbox/base';

import { styles } from './Chip.styles';

export interface ChipProps {
  option: Option;
  onRemove: () => void;
  className?: string;
}

export function Chip({ option, onRemove, className }: ChipProps) {
  const slots = styles();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <div className={slots.base({ class: className })}>
      <span>{option.label}</span>
      <button
        className={slots.closeButton()}
        type="button"
        onClick={handleClick}
      >
        <CloseIcon className={slots.closeIcon()} />
      </button>
    </div>
  );
}
